import {createStrokeSVG} from './TEMPLATE'

// tabler: info-circle
export const CircleInfo_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0', 'M12 9h.01', 'M11 12h1v4h1'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
